/**
 * Valeurs du champ `rip.clientAndPartnerSignatureDate[client|partner].type`,
 * telles qu'elles sont stockées en base. Le modèle de données reste inchangé :
 * ces constantes ne font que nommer l'existant pour éviter les chaînes magiques.
 *
 * Note : le mode électronique a deux valeurs selon l'étape :
 *  - ELECTRONIC_PENDING ('universign')   → écrit au démarrage de la transaction
 *  - ELECTRONIC_DONE ('électroniquement') → écrit à la complétion (polling)
 */
export const SIGNATURE_TYPE = {
    MANUAL: 'manuellement',
    ELECTRONIC_PENDING: 'universign',
    ELECTRONIC_DONE: 'électroniquement',
    ELECTRONIC_REFUSED: 'refusal elect',
};

/** Les deux valeurs qui désignent le mode électronique (démarrage et complétion). */
export const ELECTRONIC_TYPES = [SIGNATURE_TYPE.ELECTRONIC_PENDING, SIGNATURE_TYPE.ELECTRONIC_DONE];

export const isManualType = (type) => SIGNATURE_TYPE.MANUAL === type;

export const isElectronicType = (type) => ELECTRONIC_TYPES.includes(type);

export const isElectronicRefusedType = (type) => SIGNATURE_TYPE.ELECTRONIC_REFUSED === type;
